import { useQuery } from "@tanstack/react-query";
import { getCandidates } from "@/api/featureSpotlights";

export const CANDIDATES_QUERY_KEY = ["feature-spotlights", "candidates"];

/**
 * Uma busca por carregamento do app; depois disso, uma a cada 5 min enquanto a aba está aberta e
 * visível, e ao voltar para a aba quando já passaram 5 min. É o teto de "pausei a novidade e ela
 * ainda aparece" (SPOT-40): custa uma leitura leve a cada 5 min por pessoa.
 */
const CANDIDATES_REFRESH_MS = 5 * 60 * 1000;

/**
 * As novidades da pessoa: `{ cards, pointers }`. O cartão e o ponteiro leem a mesma consulta,
 * então o React Query faz uma única ida ao servidor.
 *
 * @param {boolean} enabled
 */
export function useCandidates(enabled) {
  return useQuery({
    queryKey: CANDIDATES_QUERY_KEY,
    queryFn: getCandidates,
    enabled,
    staleTime: CANDIDATES_REFRESH_MS,
    refetchInterval: CANDIDATES_REFRESH_MS,
    refetchIntervalInBackground: false,
    // O app desliga o refetch ao focar a aba para todo mundo (main.jsx); aqui precisa ligar: quem
    // volta depois de horas não pode esperar o próximo ciclo para ver que a novidade foi pausada.
    refetchOnWindowFocus: true,
    retry: false,
  });
}
